export default {
  GreetingMessage: "Hello!",
  WelcomeMessage: "Welcome to the online yoga studio for face and self massage!"
};
